(function() {
    PortalDropdown.$inject = ['$scope', '$location', '$q', 'toastr', '__env', 'httpService', 'readCookie'];

    angular
        .module('app')
        .component('portalDropdown', {
            templateUrl: 'common/components/portalDropdown/portalDropdown.html',
            controller: PortalDropdown,
            bindings: {}
        });

    /** @ngInject */
    /**
     * PortalDropdown
     *
     * @function createCookie
     * @param { service } $scope - the scope of the this controller
     * @param { service } $location - service to provide locations support
     * @param { service } $q - provides deferred promises support
     * @param { service } __env - The environment configuration. 
     * @param { service } httpService - provides async http requests
     * @param { service } readCookie - read cookie variables
     */

    function PortalDropdown($scope, $location, $q, toastr, __env, httpService, readCookie) {


        $scope.$on('$locationChangeSuccess', function(){
          $scope.setPageName();
         
        });

        /** 
         * Sets the menu name to the current page name based on the current url 
         *
         * @function setPageName      
         */
        $scope.setPageName = function() {

            // remove the parameters from the absolute path
            var currentPath = $location.absUrl().split('?')[0];
            var portals = $scope.userPortalList;

            // loop through portals and check for a match against the current page
            for(var i = 0; i < portals.length; i++){  

                if (currentPath == portals[i].baseUri) {

                    // set the page name
                    $scope.currentPage = portals[i].portalName;
                }

            }        
        };

        /** 
         * gets a list of all portals the user can see up front for the dropdown
         * navigation
         *
         * @function      
         */
        $scope.getUserPortals = function() {    

            return $q(function(resolve, reject) {
                sessionKey = readCookie.getByName(__env.sessionCookieName);
                $scope.userPortalList = [];
                $scope.currentPage = '';

                var currentPath = $location.absUrl();
                
                var url = __env.apiBaseUrlPortal + '/portals/session/' + sessionKey;
                var data = '';
                var type = 'get';

                httpService.asyncCall(url, type, data)
                    .then(function(response) {

                    var portals = response.data.data;

                    portals.push({
                        'portalId': 0,
                        'portalName': 'Portal Selection', 
                        'baseUri': __env.currentUrl.substring(0, __env.currentUrl.length - 1),                
                        'homePageRelativeUri': '/#/',
                        'portalTypeId': 1
                    });
                    
                    for(var i = 0; i < portals.length; i++){

                        if (portals[i].portalTypeId === 2) {
                            portals[i].baseUri += '/' + $scope.targetPage;
                        } else if (portals[i].portalTypeId === 1) {
                            portals[i].baseUri += portals[i].homePageRelativeUri;
                        }

                        
                        if (currentPath == portals[i].baseUri) {
                            $scope.currentPage = portals[i].portalName;
                        } 

                        $scope.userPortalList.push(portals[i]);
                    }   

                    resolve();     
                      

                }).catch(function(e){
                  
                    reject();        
                }); 
            });
          
        };

        /**
         * Runs first on page load and loads required data.
         *
         * @function      
         */   
        var init = function() {   

            var promise = $scope.getUserPortals();
            
            promise.then(function() {
                $scope.setPageName();
            }, function() {
                toastr.error('Could not retrieve your portals');
            });

            
            if($location.search().pg == 'undefined' || typeof($location.search().pg) == 'undefined'){
                $scope.targetPage = '';     
            } else {
                $scope.targetPage = $location.search().pg;
            }

        };

        init();
        
    }
})();